export const AppConfigs = {
  // AWS access key / secret / region removed: they were never read by any
  // client-side AWS call (the S3 upload is server-signed via
  // /api/configs/s3_signed_url/...). Shipping them only leaked an AWS key into
  // the browser bundle. Only the (non-secret) knowledge-base bucket name is used.
  REACT_APP_AWS_KNOWLEDGE_BASE_S3_BUCKET_NAME: process.env.REACT_APP_AWS_KNOWLEDGE_BASE_S3_BUCKET_NAME,
};
